import React from 'react';

// AI-generated dungeon background
const FORGE_BG_URL = "https://static.prod-images.emergentagent.com/jobs/4a995e58-eb88-4fcc-bf92-d57c0d51b824/images/4b184bdfef6623efabbb5b4fc36eb25edb39b427fa6c41ba58dd0c7788a508d7.png";

/**
 * DungeonBackground - Immersive dungeon corridor background with walls and atmosphere
 * Mobile-responsive: Uses different background strategies for mobile vs desktop
 */
export default function DungeonBackground({ children }) {
  return (
    <div className="relative w-full min-h-screen overflow-hidden">
      {/* Rich background image - mobile uses bg-scroll, desktop uses bg-fixed */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat md:bg-fixed"
        style={{
          backgroundImage: `url(${FORGE_BG_URL})`,
          filter: 'brightness(0.6)',
          // On mobile, ensure the background fills the container properly
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        }}
      />
      
      {/* Mobile-specific background layer for better coverage */}
      <div 
        className="absolute inset-0 md:hidden"
        style={{
          background: 'linear-gradient(180deg, rgba(15, 23, 42, 0.3) 0%, rgba(15, 23, 42, 0.1) 50%, rgba(15, 23, 42, 0.4) 100%)'
        }}
      />
      
      {/* Gradient overlays for depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/50" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40" />
      
      {/* Torch glow areas - reduced on mobile for performance */}
      <div 
        className="absolute inset-0 pointer-events-none hidden md:block"
        style={{
          background: `
            radial-gradient(circle at 50% 0%, rgba(255,180,60,.09), transparent 18%),
            radial-gradient(circle at 20% 20%, rgba(255,120,20,.04), transparent 16%),
            radial-gradient(circle at 80% 30%, rgba(255,140,0,.035), transparent 16%)
          `
        }}
      />
      
      {/* Simplified torch glow for mobile */}
      <div 
        className="absolute inset-0 pointer-events-none md:hidden"
        style={{
          background: 'radial-gradient(circle at 50% 30%, rgba(255,150,40,.06), transparent 40%)'
        }}
      />
      
      {/* Vignette effect */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `
            radial-gradient(
              ellipse at center,
              transparent 0%,
              transparent 40%,
              rgba(0, 0, 0, 0.5) 100%
            )
          `
        }}
      />
      
      {/* Top fog gradient */}
      <div 
        className="absolute top-0 left-0 right-0 h-24 md:h-32 pointer-events-none"
        style={{
          background: 'linear-gradient(180deg, rgba(2, 6, 23, 0.8) 0%, transparent 100%)'
        }}
      />
      
      {/* Bottom fog gradient */}
      <div 
        className="absolute bottom-0 left-0 right-0 h-24 md:h-32 pointer-events-none"
        style={{
          background: 'linear-gradient(0deg, rgba(2, 6, 23, 0.8) 0%, transparent 100%)'
        }}
      />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
